<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card>
          <div class="row">
            <div class="col-12 col-sm-6 col-md-3">
              <label for=""
                >{{ $t('common_words.date_range_selection') }}:
              </label>
              <el-date-picker
                v-if="renderComponent"
                class="shadow-sm"
                :clearable="false"
                v-model="rangeDate"
                type="daterange"
                :picker-options="pickerOptions"
                range-separator="-"
                :start-placeholder="$t('common_words.initial_date')"
                :end-placeholder="$t('common_words.final_date')"
                :align="'right'"
              >
              </el-date-picker>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <label for="">{{ $t('common_words.farm') }}: </label>
              <br />
              <el-select
                @change="selectAllFromSelect('farmSel', farms)"
                collapse-tags
                clearable
                multiple
                filterable
                style="width: 100%"
                class="select-primary custom-width-select mb-3 shadow-sm"
                v-model="farmSel"
                :placeholder="`${$t('common_words.select2')}...`"
              >
                <el-option
                  class="select-primary selected-all"
                  v-for="item in farms"
                  :key="item.id + item.name"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <label for="">{{ $t('common_words.allotment') }}: </label>
              <br />
              <el-select
                @change="selectAllFromSelect('lotSel', getLotbyFarm())"
                collapse-tags
                clearable
                multiple
                filterable
                style="width: 100%"
                class="select-primary custom-width-select mb-3 shadow-sm"
                v-model="lotSel"
                :placeholder="`${$t('common_words.select2')}...`"
              >
                <el-option
                  class="select-primary selected-all"
                  v-for="item in getLotbyFarm()"
                  :key="item.id + item.name"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-4 col-sm-6 col-md-2">
              <label for="">{{ $t('common_words.filter') }}: </label>
              <br />
              <el-select
                @change="selectAllFromSelect('optionSel', optionsReport)"
                collapse-tags
                clearable
                multiple
                filterable
                style="width: 100%"
                class="select-primary custom-width-select mb-3 shadow-sm"
                :placeholder="`${$t('common_words.select2')}...`"
                v-model="optionSel"
              >
                <el-option
                  class="select-primary selected-all"
                  v-for="item in optionsReport"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-1">
              <div class="text-left">
                <label for="" style="color: white">button</label>
                <br />
                <button
                  class="btn btn-info custom-shadow-btn"
                  @click="handleFilterRange"
                >
                  {{ $t('common_words.filter') }}
                </button>
              </div>
            </div>
          </div>
        </card>
        <card v-if="headers">
          <br />
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                filterable
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'date_save', order: 'descending' }"
                :data="queriedData"
                height="500"
                style="width: 100%"
                :border="true"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                ></el-table-column>
                <el-table-column
                  v-if="isShow() || isDelete()"
                  :min-width="110"
                  :label="$t('common_words.operations')"
                  fixed="right"
                >
                  <template slot-scope="props">
                    <div class="text-center">
                      <span v-if="props.row.show">
                        <a
                          v-if="isShow()"
                          v-tooltip.top-center="$t('common_words.view')"
                          class="btn-info btn-simple btn-link custom-margin-actions"
                          @click="handleView(props.$index, props.row)"
                        >
                          <em class="fa fa-eye custom-size-fa-actions"></em>
                        </a>
                      </span>
                      <a
                        v-if="isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDelete(props.$index, props.row)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  {{ $t('table2.showing') }} {{ from + 1 }}
                  {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                  {{ total }} {{ $t('table2.entries') }}
                </p>
              </div>
              <l-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                pageFirst="false"
                pageLast="false"
              ></l-pagination>
            </div>
          </div>
        </card>
        <div v-if="details" class="col-12 text-center">
          <em
            class="nc-icon nc-stre-up"
            style="font-size: 25px; cursor: pointer"
            @click="handleViewDetails"
            v-tooltip.top-center="$t('common_words.hide_detail')"
          ></em>
        </div>
        <card v-if="details">
          <div class="row">
            <div class="col-12">
              <p style="font-size: 17px" class="text-muted">
                {{ $t('common_words.sample_info') }}
              </p>
            </div>
            <div class="col-6">
              <table class="table">
                <tbody>
                  <tr class="shadow-sm">
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.farm') }}:</strong>
                      </h6>
                      {{ rowData.farm_name }}
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.allotment') }}:</strong>
                      </h6>
                      {{ rowData.lot_name }}
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.code') }}:</strong>
                      </h6>
                      {{ rowData.code }}
                    </td>
                    <td>
                      <img
                        v-tooltip.top-center="
                          $t('common_words.geo_location_map')
                        "
                        style="width: 30px; height: 30px"
                        class="pointer"
                        src="/static/img/iconos/map.svg"
                        alt="Icono de Geolocalización"
                        @click="handleViewSamplesMap()"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <el-dialog
              title="Mapa de muestras"
              class="zoom-map el-dialog-img-zoom"
              top="15px"
              width="80%"
              :visible.sync="modals.map"
              :close="handleCloseSamplesMap"
            >
              <div ref="multipleMap" class="map"></div>
              <div id="toolbarDiv" class="esri-component esri-widget">
                <button
                  id="distance"
                  class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                  style="margin-bottom: 10px"
                  :title="$t('common_words.distance_measurement_tool')"
                ></button>
                <button
                  id="area"
                  class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                  style="margin-bottom: 10px"
                  :title="$t('common_words.area_measurement_tool')"
                ></button>
                <button
                  id="clear"
                  class="action-button esri-widget--button esri-interactive esri-icon-trash"
                  style="margin-bottom: 10px"
                  :title="$t('common_words.clear_measurement')"
                ></button>
              </div>
            </el-dialog>
            <el-dialog
              v-if="isUpdate()"
              :title="$t('common_words.edit_sample_report')"
              :visible.sync="modals.read"
              width="80%"
            >
              <p>
                {{ $t('common_words.selected_record_info') }}
              </p>
              <form @submit.prevent="validate" v-if="this.isUpdate()">
                <card class="shadow-sm">
                  <div class="row">
                    <div class="col-6">
                      <div class="row">
                        <div class="col-12">
                          <h6 class="text-muted">
                            1. {{ $t('common_words.geo_position_sample') }}
                          </h6>
                          <hr />
                        </div>
                      </div>
                      <div class="col-12">
                        <div ref="map" class="map" style="height: 1000px"></div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="row">
                        <div class="col-12">
                          <h6 class="text-muted">
                            2. {{ $t('common_words.sample_detail') }}
                          </h6>
                          <hr />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          <fg-input
                            type="number"
                            :label="`${$t('diseases.outbreak')}: *`"
                            v-model="detailsForm.outbreak"
                            name="diseases.outbreak"
                            v-validate="modelValidations.outbreak"
                            :error="getError('diseases.outbreak', true)"
                            placeholder="1"
                            disabled="false"
                            min="0"
                          >
                          </fg-input>
                        </div>
                        <div class="col-4">
                          <fg-input
                            type="number"
                            :label="`${$t('diseases.cases_number')}: *`"
                            v-model="detailsForm.cases"
                            name="diseases.cases"
                            v-validate="modelValidations.cases"
                            :error="getError('diseases.cases', true)"
                            placeholder="1"
                            min="0"
                          >
                          </fg-input>
                        </div>
                        <div class="col-4">
                          <fg-input
                            type="text"
                            :label="`${$t('common_words.tower_number')}: *`"
                            v-model="detailsForm.tower"
                            name="tower"
                            :placeholder="$t('common_words.tower')"
                          >
                          </fg-input>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <h6 class="text-muted">
                            3. {{ $t('diseases.disease_details') }}
                          </h6>
                          <hr />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-8">
                          <div class="form-group has-label">
                            <label class="text-transform-none"
                              >{{ $t('diseases.disease_selected') }}:</label
                            >
                            <br />
                            <el-select
                              :disabled="
                                tableDataUnits.length > 0 ? true : false
                              "
                              clearable
                              class="select-primary custom-width-select shadow-sm required"
                              size="large"
                              v-model="detailsForm.disease_id"
                              :placeholder="`${$t('common_words.select')}...`"
                              filterable
                              @change="statuses(), symptoms(), changeStatus()"
                            >
                              <el-option
                                v-for="option in diseases"
                                class="select-primary"
                                :value="option.id"
                                :label="option.name"
                                :key="option.name + option.id"
                              ></el-option>
                            </el-select>
                            <label
                              class="text-transform-none"
                              style="font-size: 14px; color: red"
                              v-if="deleteUnitsLabel"
                              >{{ $t('labor.unit_edit_delete_related') }}</label
                            >
                          </div>
                        </div>
                      </div>
                      <div
                        class="row"
                        v-if="showStatuses && tableDataUnits.length == 0"
                      >
                        <div class="col-12">
                          <div class="form-group has-label">
                            <label class="text-transform-none">{{
                              $t('common_words.sample_select_diagnostic')
                            }}</label>
                            <br />
                            <el-select
                              :disabled="
                                tableDataUnits.length > 0 ? true : false
                              "
                              clearable
                              class="select-primary custom-width-select shadow-sm required"
                              size="large"
                              v-model="detailsForm.disease_status_id"
                              :placeholder="`${$t('common_words.select')}...`"
                              filterable
                            >
                              <el-option
                                v-for="option in optStatuses"
                                class="select-primary"
                                :value="option.id"
                                :label="
                                  option.state_number +
                                  ' - ' +
                                  option.disease_status
                                "
                                :key="option.disease_status"
                              ></el-option>
                            </el-select>
                            <label
                              class="text-transform-none"
                              style="font-size: 14px; color: red"
                              v-if="deleteUnitsLabel"
                              >{{ $t('labor.unit_edit_delete_related') }}</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row" v-if="showSymptoms">
                        <div class="col-12">
                          <div class="form-group has-label">
                            <label class="text-transform-none">{{
                              $t('diseases.symptom_select_sample')
                            }}</label>
                            <br />
                            <el-select
                              :disabled="
                                tableDataUnits.length > 0 ? true : false
                              "
                              collapse-tags
                              clearable
                              multiple
                              class="select-primary custom-width-select shadow-sm"
                              size="large"
                              v-model="detailsForm.disease_symptom_id"
                              :placeholder="`${$t('common_words.select')}...`"
                              filterable
                            >
                              <el-option
                                v-for="option in optSymtoms"
                                class="select-primary"
                                :value="option.id"
                                :label="option.disease_symptom"
                                :key="option.disease_symptom"
                              ></el-option>
                            </el-select>
                            <label
                              class="text-transform-none"
                              style="font-size: 14px; color: red"
                              v-if="deleteUnitsLabel"
                              >{{ $t('labor.unit_edit_delete_related') }}</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group has-label">
                            <el-input
                              type="textarea"
                              :label="$t('common_words.observation')"
                              v-model="detailsForm.observations"
                              name="observations"
                              :placeholder="$t('common_words.observation')"
                            >
                            </el-input>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <h6 class="text-muted">
                            4. {{ $t('common_words.sampling') }}
                          </h6>
                          <hr />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <fg-input
                            type="text"
                            :label="$t('common_words.oficial_id')"
                            v-model="detailsForm.collection.official_id"
                          >
                          </fg-input>
                        </div>
                        <div class="col-6">
                          <fg-input
                            type="text"
                            :label="$t('common_words.oficial_name')"
                            v-model="detailsForm.collection.official_name"
                          >
                          </fg-input>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <div class="form-group has-label">
                            <label>{{ $t('common_words.observations') }}</label>
                            <el-input
                              type="textarea"
                              :label="$t('common_words.observations')"
                              v-model="detailsForm.collection.observations"
                              :placeholder="$t('common_words.observations')"
                            >
                            </el-input>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group has-label">
                            <label>{{ $t('common_words.sample_take') }}</label>
                            <el-select
                              class="select-primary custom-width-select shadow-sm"
                              v-model="detailsForm.collection.sample"
                            >
                              <el-option
                                class="select-primary"
                                :label="$t('common_words.mayus_no')"
                                :value="0"
                              ></el-option>
                              <el-option
                                class="select-primary"
                                :label="$t('common_words.mayus_yes')"
                                :value="1"
                              ></el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <div class="form-group has-label">
                            <label>{{ $t('common_words.date') }}</label>
                            <el-input
                              disabled
                              v-model="detailsForm.collection.full_date"
                            >
                            </el-input>
                          </div>
                        </div>
                        <div
                          class="col-6 form-group has-label"
                          style="margin-top: 30px"
                        >
                          <button
                            type="submit"
                            class="btn btn-fill btn-info btn-wd shadow-sm"
                          >
                            {{ $t('common_words.edit') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                </card>
              </form>
              <br />
            </el-dialog>
            <el-dialog
              :visible.sync="modalUnit.read"
              :title="$t('common_words.edit_sample_report')"
              width="80%"
              :close="handleClose"
            >
              <p>
                {{ $t('labor.unit_find_selected_info') }}
              </p>
              <form @submit.prevent="validateUnit" v-if="this.isUpdate()">
                <card class="shadow-sm">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-12">
                          <h6 class="text-muted">
                            1. {{ $t('common_words.sample_detail') }}
                          </h6>
                          <hr />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          <fg-input
                            type="number"
                            disabled
                            :label="`${$t('common_words.sample')}: *`"
                            v-model="unitForm.sample"
                            name="common_words.sample"
                            v-validate="modelValidations.sample"
                            :error="getError('common_words.sample', true)"
                            min="0"
                          >
                          </fg-input>
                        </div>
                      </div>
                      <div class="row" v-if="showStatuses">
                        <div class="col-12">
                          <div class="form-group has-label">
                            <label class="text-transform-none">{{
                              $t('common_words.sample_select_diagnostic')
                            }}</label>
                            <br />
                            <el-select
                              clearable
                              class="select-primary custom-width-select shadow-sm required"
                              size="large"
                              v-model="unitForm.disease_status_id"
                              :placeholder="`${$t('common_words.select')}...`"
                              filterable
                            >
                              <el-option
                                v-for="option in optStatuses"
                                class="select-primary"
                                :value="option.id"
                                :label="
                                  option.state_number +
                                  ' - ' +
                                  option.disease_status
                                "
                                :key="option.disease_status"
                              ></el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-12 text-right">
                      <button
                        type="submit"
                        class="btn btn-fill btn-info btn-wd shadow-sm"
                      >
                        {{ $t('common_words.edit') }}
                      </button>
                    </div>
                  </div>
                </card>
              </form>
              <br />
            </el-dialog>
            <div class="col-12">
              <hr />
              <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <el-select
                  clearable
                  @clear="paginationDetails.perPage = 10"
                  filterable
                  class="select-default mb-3 shadow-sm"
                  style="width: 200px"
                  v-model="paginationDetails.perPage"
                  :placeholder="$t('common_words.per_page')"
                >
                  <el-option
                    class="select-default"
                    v-for="item in paginationDetails.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <el-input
                  clearable
                  class="mb-3 shadow-sm"
                  style="width: 200px"
                  :placeholder="$t('common_words.search_records')"
                  v-model="searchQueryDetails"
                  aria-controls="datatables"
                />
              </div>
              <el-table
                stripe
                :default-sort="{ prop: 'id', order: 'ascending' }"
                style="width: 100%"
                :data="queriedDataDetails"
                :border="true"
              >
                <el-table-column
                  v-for="column in tableColumnsDetails"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                ></el-table-column>

                <el-table-column :label="$t('common_words.altitude')">
                  <template slot-scope="props">
                    {{
                      (function () {
                        if (props.row.altitude) {
                          return Number.parseFloat(props.row.altitude).toFixed(
                            2
                          );
                        }
                        return null;
                      })()
                    }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="outbreak"
                  :label="$t('diseases.outbreak')"
                  minWidth:70
                >
                </el-table-column>

                <el-table-column
                  prop="cases"
                  :label="$t('diseases.cases')"
                  minWidth:70
                >
                </el-table-column>

                <el-table-column
                  prop="disease.name"
                  :label="$t('diseases.disease')"
                  minWidth:150
                >
                </el-table-column>

                <el-table-column
                  prop="disease_status.disease_status"
                  :label="$t('common_words.level_or_status')"
                  minWidth="150"
                ></el-table-column>

                <el-table-column :label="$t('diseases.symptom')" minWidth="150">
                  <template slot-scope="props">
                    <ul>
                      <li
                        v-for="(symptom, index) in props.row.symptoms"
                        :key="index + 'symptom'"
                      >
                        {{ symptom.disease_symptom }}
                      </li>
                    </ul>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="observations"
                  :label="$t('common_words.observations')"
                  minWidth="150"
                ></el-table-column>

                <el-table-column
                  :label="$t('common_words.image')"
                  min-width="150"
                >
                  <template slot-scope="scope">
                    <el-image
                      v-if="scope.row.image"
                      :src="scope.row.image"
                      :alt="$t('common_words.no_image')"
                      class="photo_capture"
                      @click="zoom(scope.row.image)"
                      :preview-src-list="srcList"
                    >
                      <div slot="error" class="image-slot"></div>
                    </el-image>
                    <span v-else></span>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="70"
                  :label="$t('common_words.action')"
                  fixed="right"
                >
                  <template slot-scope="props">
                    <div class="text-center">
                      <a
                        v-if="isShow()"
                        v-tooltip.top-center="$t('common_words.view')"
                        class="btn-info btn-simple btn-link custom-margin-actions"
                        @click="handleViewDetailUnits(props.$index, props.row)"
                      >
                        <em class="fa fa-eye custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.edit')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click="handleEdit(props.$index, props.row)"
                      >
                        <em class="fa fa-edit custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDeleteDetails(props.$index, props.row)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <br />
              <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class>
                  <p class="card-category">
                    {{ $t('table2.showing') }} {{ fromDetails + 1 }}
                    {{ $t('table2.a') }} {{ toDetails }} {{ $t('table2.of') }}
                    {{ totalDetails }} {{ $t('table2.entries') }}
                  </p>
                </div>
                <l-pagination
                  class="pagination-no-border"
                  v-model="paginationDetails.currentPage"
                  :per-page="paginationDetails.perPage"
                  :total="paginationDetails.total"
                  pageFirst="false"
                  pageLast="false"
                ></l-pagination>
              </div>
            </div>
          </div>
          <div class="row" style="padding-right: 13px; padding-left: 13px">
            <div class="col-6" v-if="isPDF()">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportToPDF"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-6" v-if="isExcel()">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToExcel"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </card>

        <div v-if="detailsUnit" class="col-12 text-center">
          <em
            id="unitDetails"
            class="nc-icon nc-stre-up"
            style="font-size: 25px"
            @click="handleViewDetailUnits"
            v-tooltip.top-center="$t('common_words.hide_detail')"
          ></em>
        </div>

        <card v-if="detailsUnit">
          <div class="row">
            <div class="col-12">
              <p style="font-size: 17px" class="text-muted">
                {{ $t('common_words.detailed_information') }}
              </p>
            </div>

            <div class="col-12">
              <hr />
              <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <el-select
                  clearable
                  @clear="paginationUnits.perPage = 10"
                  filterable
                  class="select-default mb-3 shadow-sm"
                  style="width: 200px"
                  v-model="paginationUnits.perPage"
                  :placeholder="$t('common_words.per_page')"
                >
                  <el-option
                    class="select-default"
                    v-for="item in paginationUnits.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <el-input
                  clearable
                  class="mb-3 shadow-sm"
                  style="width: 200px"
                  :placeholder="$t('common_words.search_records')"
                  v-model="searchQueryUnits"
                  aria-controls="datatables"
                />
              </div>
              <el-table
                stripe
                :default-sort="{ prop: 'id', order: 'ascending' }"
                style="width: 100%"
                :data="queriedDataUnits"
                :border="true"
              >
                <el-table-column
                  v-for="column in tableColumnsUnits"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                ></el-table-column>

                <el-table-column
                  :min-width="70"
                  :label="$t('common_words.action')"
                  fixed="right"
                >
                  <template slot-scope="props">
                    <div class="text-center">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.edit')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click="handleEditUnit(props.$index, props.row)"
                      >
                        <em class="fa fa-edit custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDeleteUnit(props.$index, props.row)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <br />
              <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class>
                  <p class="card-category">
                    {{ $t('table2.showing') }} {{ fromUnits + 1 }}
                    {{ $t('table2.a') }} {{ toUnits }} {{ $t('table2.of') }}
                    {{ totalUnits }} {{ $t('table2.entries') }}
                  </p>
                </div>
                <l-pagination
                  class="pagination-no-border"
                  v-model="paginationUnits.currentPage"
                  :per-page="paginationUnits.perPage"
                  :total="paginationUnits.total"
                  pageFirst="false"
                  pageLast="false"
                ></l-pagination>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import Fuse from 'fuse.js';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import moment from 'moment';
import i18n from 'src/i18n';
import configTable from './sampleTable';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    LPagination,
  },

  computed: {
    ...configTable().searchs,
    /* ...configTable().searchUnits, */
  },

  data() {
    return {
      optionsReport: this.concatAll([
        { id: 1, name: 'Plaga' },
        { id: 2, name: 'Enfermedad' },
      ]),
      optionSel: [],
      srcList: [],
      sampleForm: {},
      detailsForm: {
        collection: {},
      },
      unitForm: {},
      headers: true,
      paginationDetails: {},
      paginationUnits: {},
      tableColumns: [],
      tableColumnsDetails: [],
      tableColumnsUnits: [],
      searchQueryDetails: '',
      searchQueryUnits: '',
      tableDataDetails: [],
      tableDataUnits: [],
      deleteUnitsLabel: false,
      detailsUnit: false,
      fuseSearchDetails: null,
      fuseSearchUnits: null,
      details: false,
      modalUnit: {
        read: false,
      },
      modelValidations: {
        latitude: {
          required: true,
        },
        longitude: {
          required: true,
        },
        cases: {
          required: true,
        },
        outbreak: {
          required: true,
        },
      },
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      diseases: [],
      optStatuses: [],
      optSampleSymtoms: [],
      showStatuses: false,
      showSymptoms: false,
      farms: [],
      farmSel: [],
      lotSel: [],
      map: null,
    };
  },

  mixins: [
    MixinPermissions,
    MixinDatePicker,
    MixinForm,
    MixinArcgisMap,
    mixinMasters,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': ['getSelectAll', 'setupTable', 'forceRerender'],
  },

  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },
    zoom(url) {
      this.srcList = [];
      this.srcList.push(url);
    },

    getLotbyFarm() {
      let resp = [];
      for (let index = 0; index < this.farms.length; index++) {
        const element = this.farms[index];
        if (this.farmSel.includes(element.id)) {
          element.lots.forEach((item) => {
            resp.push({
              id: item.id,
              name:
                i18n.t('common_words.farm') +
                ' ' +
                element.name +
                ' - ' +
                item.name,
            });
          });
        }
      }

      return this.concatAll(resp);
    },

    changeStatus() {
      this.detailsForm.disease_status_id = null;
      this.detailsForm.disease_symptom_id = [];
      this.detailsForm.disease_sample_symptom_id = [];
    },

    statuses() {
      this.optStatuses = Object.assign({}, []);
      let find = false;
      for (let index = 0; index < this.diseases.length; index++) {
        const element = this.diseases[index];
        if (this.detailsForm.disease_id == element.id) {
          find =
            element.disease_statuses.length > 0 && element.catch_type == '1'
              ? true
              : false;
          this.optStatuses = Object.assign(
            {},
            find ? element.disease_statuses : []
          );
          break;
        }
      }

      this.showStatuses = find;
      this.detailsForm.disease_status_id = !find
        ? null
        : this.detailsForm.disease_status_id;
    },

    symptoms() {
      this.optSymtoms = Object.assign({}, []);
      this.showSymptoms = false;
      for (let index = 0; index < this.diseases.length; index++) {
        const element = this.diseases[index];
        if (this.detailsForm.disease_id == element.id) {
          this.optSymtoms = Object.assign(
            {},
            element.disease_symptoms_para_editar
          );

          this.detailsForm = Object.assign(
            {},
            {
              ...this.detailsForm,
              disease_symptom_id: [],
              disease_sample_symptom_id: [],
            }
          );
          this.detailsForm.disease_symptom_id = this.detailsForm.symptoms.map(
            (el) => el.id
          );
          // this.detailsForm.disease_sample_symptom_id = this.detailsForm.symptoms.map((el) => el.disease_sample_symptom_id);
          if (this.detailsForm.number_symptoms > 0) {
            this.showSymptoms = true;
          }
          break;
        }
      }
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          return store
            .dispatch('utils/validationInputsRequired', '')
            .then((resp) => {
              if (resp) {
                this.modals['read'] = false;
                this.showHideLoading(true);
                if (this.isUpdate()) {
                  this.detailsForm.route = 'diseases/diseasesampledetails';
                  Axios.updateMaster(this.detailsForm)
                    .then((response) => {
                      this.showHideLoading();
                      SweetAlert.success(response.data.message).then(() => {
                        this.$set(
                          this.tableDataDetails,
                          this.detailsForm.index,
                          response.data.data
                        );
                      });
                    })
                    .catch((error) => {
                      this.showHideLoading();
                      let msg = '';
                      if (error.response.data.errors) {
                        for (var key in error.response.data.errors) {
                          msg += error.response.data.errors[key] + '<br/>';
                        }
                      } else msg = error.response.data.message;

                      SweetAlert.danger(msg);
                    });
                } else {
                  this.showMessageAccess();
                  this.showHideLoading();
                }
              }
            });
        }
      });
    },

    validateUnit() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          return store
            .dispatch('utils/validationInputsRequired', '')
            .then((resp) => {
              if (resp) {
                this.modalUnit['read'] = false;
                this.showHideLoading(true);
                if (this.isUpdate()) {
                  this.unitForm.route = 'diseases/diseasesampleunits';
                  Axios.updateMaster(this.unitForm)
                    .then((response) => {
                      this.showHideLoading();
                      this.detailsUnit = false;
                      SweetAlert.success(response.data.message).then(() => {
                        // this.$set(
                        //   this.tableDataUnits,
                        //   this.unitForm.index,
                        //   response.data.data
                        // );
                      });
                    })
                    .catch((error) => {
                      this.detailsUnit = false;
                      this.showHideLoading();
                      let msg = '';
                      if (error.response.data.errors) {
                        for (var key in error.response.data.errors) {
                          msg += error.response.data.errors[key] + '<br/>';
                        }
                      } else msg = error.response.data.message;

                      SweetAlert.danger(msg);
                    });
                } else {
                  this.showMessageAccess();
                  this.showHideLoading();
                }
              }
            });
        }
      });
    },

    handleClose(done) {
      this.detailsForm = [];
    },

    handleCloseSamplesMap() {
      this.modals.map = false;
    },

    handleViewSamplesMap() {
      this.modals.map = true;
      this.showHideLoading(true);

      let points = [];
      this.tableDataDetails.forEach((element) => {
        let pll = new Object();
        pll.lat = parseFloat(element.latitude);
        pll.lng = parseFloat(element.longitude);
        pll.name = element.disease.name;
        pll.color = element.disease.color;
        this.center.lat = element.latitude
          ? parseFloat(element.latitude)
          : this.center.lat;
        this.center.lng = element.longitude
          ? parseFloat(element.longitude)
          : this.center.lng;

        points.push(pll);
      });
      setTimeout(() => {
        this.loadBaseMap(
          this.rowData.farm_id,
          true,
          true,
          this.$refs.multipleMap,
          points,
          15
        );
        document.getElementById('toolbarDiv').style = 'top: 16%;right: 18px;';
        this.showHideLoading();
      }, 10);
    },

    handleViewDetails() {
      this.details = !this.details;
      this.tableData.forEach((element) => {
        element.show = true;
      });
    },

    loadUnitWhenEditDetail(index, row) {
      Axios.getMasters('diseases/diseasesampleunits/' + row.code_detail)
        .then((response) => {
          this.tableDataUnits = response.data.data.units;

          if (this.tableDataUnits.length > 0) {
            this.deleteUnitsLabel = true;
          }
        })
        .catch((error) => {
          SweetAlert.warning(error.response.data.message);
        });
    },

    handleViewDetailUnits(index, row) {
      this.detailsForm = Object.assign({}, row);
      this.detailsForm.index = index;
      this.detailsUnit = !this.detailsUnit;
      Axios.getMasters('diseases/diseasesampleunits/' + row.code_detail)
        .then((response) => {
          this.tableDataUnits = response.data.data.units;
          if (this.tableDataUnits.length == 0) {
            SweetAlert.warning(
              i18n.t('sweet_alert.disease.unavailable_sample_units')
            );
            this.detailsUnit = false;
          } else {
            this.detailsUnit = true;
          }
          this.fuseSearchUnits = new Fuse(this.tableDataUnits, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumnsUnits.map((prop) => {
              return prop.prop;
            }),
          });

          this.showHideLoading();

          setTimeout(() => {
            const unitDetails = document.getElementById('unitDetails');
            if (unitDetails) {
              window.scrollTo({
                top: unitDetails.offsetTop + 2000,
                behavior: 'smooth',
              });
            }
          }, 100);
        })
        .catch((error) => {
          this.showHideLoading();
          row.show = true;
          SweetAlert.warning(error.response.data.message);
        });
    },

    geoMap() {
      this.center.lat = this.detailsForm.latitude
        ? parseFloat(this.detailsForm.latitude)
        : this.center.lat;
      this.center.lng = this.detailsForm.longitude
        ? parseFloat(this.detailsForm.longitude)
        : this.center.lng;

      this.loadBaseMap(this.detailsForm.disease_sample.farm_id);
    },

    handleEdit(index, row) {
      this.deleteUnitsLabel = false;

      // if(this.tableDataUnits.length == 0){
      this.detailsUnit = false;
      // }
      this.detailsForm = Object.assign({}, row);
      this.detailsForm.index = index;
      this.statuses();
      this.symptoms();
      this.loadUnitWhenEditDetail(index, row);
      this.center.lat = this.detailsForm.latitude
        ? parseFloat(this.detailsForm.latitude)
        : this.center.lat;
      this.center.lng = this.detailsForm.longitude
        ? parseFloat(this.detailsForm.longitude)
        : this.center.lng;

      this.modals['read'] = true;
      let points = [];
      let pll = new Object();
      pll.lat = this.center.lat;
      pll.lng = this.center.lng;
      points.push(pll);

      this.loadBaseMap(
        this.rowData.farm_id,
        false,
        false,
        this.$refs.multipleMap,
        points,
        15
      );
      // this.loadBaseMap(this.detailsForm.disease_sample.farm_id);
    },

    handleEditUnit(index, row) {
      this.modalUnit.read = true;
      this.unitForm = Object.assign({}, row);
      this.unitForm.index = index;
      this.statuses();
      this.symptoms();
    },

    handleView(index, row) {
      this.tableDataDetails = [];
      this.details = false;
      this.tableDataUnits = [];
      this.detailsUnit = false;
      this.showHideLoading(true);

      this.details = false;
      this.rowData = row;
      this.rowData.index = index;

      this.tableData.forEach((element) => {
        if (element.code != this.rowData.code) element.show = true;
        else this.rowData.show = false;
      });

      let data = {
        route: 'diseases/diseasesampledetails/',
        code: this.rowData.code,
        type_disease: this.optionSel,
      };

      Axios.postMasters(data)
        .then((response) => {
          this.tableDataDetails = response.data.data;
          if (!this.tableDataDetails || this.tableDataDetails.length == 0) {
            this.details = false;
            SweetAlert.warning(
              i18n.t('sweet_alert.disease.no_detailed_information')
            );
          } else {
            this.details = true;
          }

          this.fuseSearchDetails = new Fuse(this.tableDataDetails, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumnsDetails
              .map((prop) => {
                return prop.prop;
              })
              .concat(['code']),
          });

          this.showHideLoading();

          setTimeout(() => {
            window.scrollTo({
              top:
                document.getElementsByClassName('footer')[0].offsetTop - 1000,
              behavior: 'smooth',
            });
          }, 100);
        })
        .catch((error) => {
          this.showHideLoading();
          this.rowData.show = true;
          SweetAlert.warning(error.response.data.message);
        });
    },

    handleDeleteDetails(index, row) {
      this.detailsForm = Object.assign({}, row);
      SweetAlert.delete(
        i18n.t('diseases.diagnosis') +
          (this.detailsForm.disease_status
            ? this.detailsForm.disease_status.disease_status
            : this.detailsForm.disease.name)
      ).then((result) => {
        if (result.value) this.deleteDetail();
      });
    },

    handleDelete(index, row) {
      this.sampleForm = Object.assign({}, row);
      SweetAlert.delete(this.sampleForm.code).then((result) => {
        if (result.value) this.deleteSample();
      });
    },

    handleDeleteUnit(index, row) {
      this.unitForm = Object.assign({}, row);
      SweetAlert.delete(
        `${i18n.t('common_words.sample')} ${this.unitForm.sample}`
      ).then((result) => {
        if (result.value) this.deleteUnit();
      });
    },

    handleFilterRange() {
      this.detailsUnit = false;
      this.tableDataUnits = [];
      this.details = false;
      this.getDataSamples();
    },

    deleteDetail() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        if (this.tableDataDetails.length == 1) {
          this.rowData.deleteHeader = true;
        }

        this.detailsForm.route = 'diseases/diseasesampledetails';
        Axios.destroyMaster(this.detailsForm)
          .then((response) => {
            this.modifyTable(
              2,
              this.detailsForm.id,
              response,
              null,
              'nc-simple-remove',
              'danger',
              this.tableDataDetails
            );
            if (this.tableDataDetails.length === 0) {
              this.modifyTable(
                2,
                this.detailsForm.code,
                response,
                null,
                'nc-simple-remove',
                'danger',
                this.tableData,
                true,
                false
              );
            }
            this.tableDataUnits = [];
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    deleteUnit() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        if (this.tableDataUnits.length == 1) {
          this.rowData.deleteHeader = true;
        }

        this.unitForm.route = 'diseases/diseasesampleunits';
        Axios.destroyMaster(this.unitForm)
          .then((response) =>
            this.modifyTable(
              2,
              this.unitForm.id,
              response,
              null,
              'nc-simple-remove',
              'danger',
              this.tableDataUnits
            )
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    deleteSample() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.sampleForm.route = 'diseases/diseasesamples';
        this.sampleForm.id = this.sampleForm.code;
        Axios.destroyMaster(this.sampleForm)
          .then((response) => {
            this.modifyTable(
              2,
              this.sampleForm.code,
              response,
              null,
              'nc-simple-remove',
              'danger',
              this.tableData,
              true,
              false
            );
            this.tableDataDetails = [];
            this.tableDataUnits = [];
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {
        route: 'diseases/diseasesampledetails/pdf',
        type_disease: this.optionSel,
        code: this.rowData.code,
        name_file: 'informe.pdf',
      };

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      let data = {
        route: 'diseases/diseasesampledetails/excel',
        type_disease: this.optionSel,
        code: this.rowData.code,
        name_file: 'informe.xlsx',
      };

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    getDataSamples() {
      this.showHideLoading(true);
      let data = {
        route: 'diseases/diseasesamples/filter',
        datei: moment(this.rangeDate[0]).format('YYYY-MM-DD'),
        datef: moment(this.rangeDate[1]).format('YYYY-MM-DD'),
        farm: this.farmSel,
        lot: this.lotSel,
        type_disease: this.optionSel,
      };

      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            this.headers = false;
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.headers = true;
          }

          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table, TableDetails, TableUnits } = configTable();

      this.pagination = { ...Table.pagination };
      this.tableColumns = Table.tableColumns;

      this.paginationDetails = { ...TableDetails.pagination };
      this.tableColumnsDetails = TableDetails.tableColumns;

      this.paginationUnits = { ...TableUnits.pagination };
      this.tableColumnsUnits = TableUnits.tableColumns;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      Axios.getMasters('diseases/diseases/').then((response) => {
        this.diseases = response.data.data;
      });

      Axios.getMasters('farms/farms/only').then((response) => {
        this.farms = this.concatAll(response.data.data);
      });

      this.getDataSamples();
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('diseases');
  },

  destroyed() {
    this.deselectedItemOnMenu('diseases');
  },
};
</script>
<style></style>
